import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { CountDownComponent } from '../../components/count-down/count-down.component';

@Component({
    selector: 'app-bets-status',
    standalone: true,
    imports: [CommonModule, CountDownComponent],
    templateUrl: './bets-status.component.html',
    styleUrl: './bets-status.component.scss'
})
export class BetsStatusComponent implements OnInit {
    private static readonly secondsToMsFactor = 1000;
    private static readonly updateIntervalMs = 200;
    private static readonly startingHue = 160;
    private static readonly maxAmount = 315;
    private static readonly defaultHurryUpPoint = 0.33;

    @Input()
    initialTimeInSeconds!: number;

    @Input()
    animate = true;

    @Input()
    hurryUpPoint = BetsStatusComponent.defaultHurryUpPoint;

    @Input()
    restart?: Observable<void>;

    protected countDownEnabled = true;
    protected hurryUp = false;

    ngOnInit(): void {
        this.restart?.subscribe(() => this.restartCountDown());
    }

    restartCountDown(): void {
        this.countDownEnabled = false;
        setTimeout(() => (this.countDownEnabled = true));
    }

    onCountDownProgress(progress: number): void {
        if (progress < this.hurryUpPoint) {
            this.hurryUp = true;
        }
    }
}
